import React from 'react'

const KeylessCipherTheory = () => {
    return (
        <div>
            <ul>
                <li>
                    <p>
                        The KeyLess Transposition Cipher technique is a simple form of transposition cipher, it is also called as rail fence technique . It’s a type of cryptographic algorithm that rearranges the positions of the letters in a message to create a new, seemingly unrelated message. The technique gets its name from the way we write the message. Applying the rail fence technique in a given text results in a zigzag pattern, with each letter in a row written out before moving to the next row.
                    </p>
                </li>
                <li>
                    <p>
                       To encrypt a message using the rail fence technique, first, we need to write the message in the first row of a table. Furthermore, we have to write the second letter of the message in the second row. We need to continue this process until we’ve written all the letters in the message. Finally, in order to generate the encrypted message, we read the table row-wise.
                    </p>
                </li>
                <li>
                    <p>
                        Now let's talk about how we can decrypt a message. To decrypt an encrypted message, the first step is to determine the number of rows in the table based on the length of the encrypted message. Furthermore, we need to write the first letter of the encrypted message in the first row, the second letter in the second row, and so on. We need to continue this process until we’ve written all the letters in the message.
                    </p>
                </li>
    
            </ul>
        </div>
    )
}

export default KeylessCipherTheory